import { Link, useSearchParams } from 'react-router';

/* ============================================================================
   /payment/success — where Razorpay sends someone back to.
   ----------------------------------------------------------------------------
   Unreachable today: Razorpay KYC is not live, so nothing redirects here yet.
   It exists because the brief had a checkout with nowhere to land, and a
   redirect target that does not exist is a blank page at the worst possible
   moment — right after someone has parted with money.

   **It does not claim the invoice is paid.** The browser arriving here is the
   party who benefits from that claim; only a verified webhook marks anything
   paid. So the wording is "payment ho gaya" — which is what the gateway told
   the browser — followed by the honest state: the receipt follows once we have
   confirmation from the bank's side.
   ========================================================================== */

export function PaymentSuccessPage() {
  const [params] = useSearchParams();
  const invoiceId = params.get('invoice');

  return (
    <section className="card stack center">
      <h1 className="h1">Payment ho gaya</h1>
      <p className="muted">
        Dhanyavaad. Bank se confirmation aate hi bill "mil gaya" ho jayega — usme thoda time lag
        sakta hai. Receipt WhatsApp par bhej denge.
      </p>
      <Link className="btn" to={invoiceId ? `/invoices/${invoiceId}` : '/invoices'}>
        Bill dekhiye
      </Link>
    </section>
  );
}
